import { getClassLevelCode, getPrimaryStandardLevel } from "../../../utils/classScopeMatch";

/** Std 1–4: no Agriculture, Primary Science, or Social Studies. */
export const PRIMARY_SUBJECTS_LOWER = [
    { key: "eng", subName: "English", sessions: "4", isElective: false, mieSyllabusCode: "" },
    { key: "mat", subName: "Mathematics", sessions: "5", isElective: false, mieSyllabusCode: "" },
    { key: "chc", subName: "Chichewa", sessions: "4", isElective: false, mieSyllabusCode: "" },
    { key: "ea", subName: "Expressive Arts", sessions: "2", isElective: false, mieSyllabusCode: "" },
    { key: "bk", subName: "Bible Knowledge", sessions: "2", isElective: false, mieSyllabusCode: "" },
    { key: "ls", subName: "Luso la moyo wabwino", sessions: "2", isElective: false, mieSyllabusCode: "" },
];

/** Std 5–8: full primary compulsory set. */
export const PRIMARY_SUBJECTS_UPPER = [
    { key: "mat", subName: "Mathematics", sessions: "5", isElective: false, mieSyllabusCode: "" },
    { key: "chc", subName: "Chichewa", sessions: "4", isElective: false, mieSyllabusCode: "" },
    { key: "psci", subName: "Primary Science", sessions: "4", isElective: false, mieSyllabusCode: "" },
    { key: "ss", subName: "Social Studies", sessions: "3", isElective: false, mieSyllabusCode: "" },
    { key: "agr", subName: "Agriculture", sessions: "3", isElective: false, mieSyllabusCode: "" },
    { key: "ea", subName: "Expressive Arts", sessions: "2", isElective: false, mieSyllabusCode: "" },
    { key: "ls", subName: "Life Skills", sessions: "2", isElective: false, mieSyllabusCode: "" },
    { key: "bk", subName: "Bible Knowledge", sessions: "2", isElective: false, mieSyllabusCode: "" },
];

/** @deprecated Use getPrimarySubjectPresets(classRow) */
export const PRIMARY_SUBJECTS = PRIMARY_SUBJECTS_UPPER;

export const PRIMARY_SCHOOL_SUBJECT_OPTIONS_LOWER = PRIMARY_SUBJECTS_LOWER.map((s) => s.subName);
export const PRIMARY_SCHOOL_SUBJECT_OPTIONS_UPPER = PRIMARY_SUBJECTS_UPPER.map((s) => s.subName);

export function isPrimaryLowerStandard(classRow) {
    const code = getClassLevelCode(classRow);
    if (["Std1", "Std2", "Std3", "Std4"].includes(code)) return true;
    const name = String(classRow?.sclassName || "").trim();
    return /^std(?:andard)?\s*[1-4]\b/i.test(name);
}

function presetsFromList(list) {
    return list.map((base) => ({
        id: `primary-${base.key}`,
        formLevel: "Primary",
        label: `${base.subName} — Compulsory · ${base.sessions} p/w`,
        subName: base.subName,
        sessions: base.sessions,
        isElective: base.isElective,
        mieSyllabusCode: base.mieSyllabusCode || "",
    }));
}

export function getPrimarySubjectPresets(classRow) {
    const list = classRow && isPrimaryLowerStandard(classRow)
        ? PRIMARY_SUBJECTS_LOWER
        : PRIMARY_SUBJECTS_UPPER;
    return presetsFromList(list);
}

export function getPrimarySubjectOptionsForClass(classRow) {
    return isPrimaryLowerStandard(classRow)
        ? [...PRIMARY_SCHOOL_SUBJECT_OPTIONS_LOWER]
        : [...PRIMARY_SCHOOL_SUBJECT_OPTIONS_UPPER];
}

/** Success text after saving primary subjects for a class. */
export function getPrimarySubjectSuccessMessage(classRow) {
    const stdLabel = getPrimaryStandardLevel(classRow) ||
        (isPrimaryLowerStandard(classRow) ? "Std 1–4" : "Std 5–8");
    if (isPrimaryLowerStandard(classRow)) {
        return (
            `Subjects saved for ${stdLabel}. This class should have English, Mathematics, Chichewa, ` +
            "Expressive Arts, Bible Knowledge, and Luso la moyo wabwino. Assign teachers when you are ready."
        );
    }
    return (
        `Subjects saved for ${stdLabel}. This class should have Mathematics, Chichewa, Primary Science, ` +
        "Social Studies, Agriculture, Expressive Arts, Life Skills, and Bible Knowledge. Assign teachers when you are ready."
    );
}

/** Message when preset rows are added to the form (before save). */
export function getPrimaryPresetAddedMessage(classRow, count) {
    const stdLabel = getPrimaryStandardLevel(classRow) ||
        (isPrimaryLowerStandard(classRow) ? "Std 1–4" : "Std 5–8");
    return `${count} ${stdLabel} subject${count === 1 ? "" : "s"} added to the list. Click Save subjects to confirm.`;
}
